// extracted by mini-css-extract-plugin
export default {"ce-header":"Editor__ce-header--53Wn3m","ce-header__icon":"Editor__ce-header__icon--yT4NTp"};